<template>
  <div id="image-display">
    <div class="row">
      <div class="col">
        <img style="width: 500px" class="img-thumbnail" :src="imgSrc">
      </div>
    </div>
    <div class="row pt-1">
      <div class="col">{{ caption }}</div>
      <div class="col-auto">
        <a v-if="popoverContent" href="#" onclick="return false;" tabindex="0" data-toggle="popover"
           data-trigger="focus" title="Info" :data-content="popoverContent">Info</a>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery';

  export default {
    name: 'image-display',
    props: [
      'caption',
      'imgSrc',
      'popoverContent'
    ],
    mounted: function() {
      $(function() {
        $('[data-toggle="popover"]').popover();
      });

      $('.popover-dismiss').popover({
        trigger: 'focus',
        title: 'Info'
      });
    },
    beforeDestroy: function() {
      $('.popover').popover('dispose');
    },
    data: function() {
      return {};
    }
  };
</script>